<template>
  <section id="about" class="scroll-mt-24 border-y border-white/5 bg-[#0e0e14] py-24">
    <div class="page-shell">
      <div class="grid grid-cols-1 gap-16 md:grid-cols-2">
        <div>
          <h2 class="section-title">{{ t(aboutTitle) }}</h2>
          <p class="mt-6 max-w-xl text-base leading-8 text-[#8b8b99]">
            {{ t(aboutDescription) }}
          </p>
        </div>

        <div id="contact" class="scroll-mt-24">
          <p class="text-xs uppercase tracking-[0.28em] text-[#8b8b99]">{{ t(contactLabel) }}</p>
          <div class="mt-4 rounded-2xl border border-white/10 bg-white/[0.04] p-4">
            <p class="text-sm font-semibold text-[#f1f1f3]">{{ t(coopTitle) }}</p>
            <p class="mt-2 text-sm leading-7 text-[#8b8b99]">
              {{ t(coopDescription) }}
            </p>
            <a
              href="mailto:beibei@beiyidata.cn"
              target="_blank"
              rel="noopener noreferrer"
              class="mt-3 inline-block text-sm text-cyan-100 transition-colors duration-200 hover:text-white"
            >
              beibei@beiyidata.cn
            </a>
          </div>

          <p class="mt-8 text-xs uppercase tracking-[0.28em] text-[#8b8b99]">{{ t(responseLabel) }}</p>
          <p class="mt-3 text-sm leading-7 text-[#8b8b99]">
            {{ t(responseDescription) }}
          </p>

          <p class="mt-8 text-xs uppercase tracking-[0.28em] text-[#8b8b99]">{{ t(locationLabel) }}</p>
          <p class="mt-3 text-sm text-[#f1f1f3]">武汉贝易科技有限公司 · Wuhan, China</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()
const aboutTitle = {
  zh: 'About Beiyi Data / 关于贝易',
  en: 'About Beiyi Data',
  es: 'Sobre Beiyi Data',
  fr: 'À propos de Beiyi Data',
  ja: 'Beiyi Data について',
}
const aboutDescription = {
  zh: 'Beiyi Data（武汉贝易科技有限公司）是一家专注 AI 工具、消费应用与企业数据产品的独立软件公司。',
  en: 'Beiyi Data is an independent software company focused on AI tools, consumer apps, and enterprise data products.',
  es: 'Beiyi Data es una empresa de software independiente centrada en herramientas de IA, apps de consumo y productos de datos empresariales.',
  fr: "Beiyi Data est une société logicielle indépendante axée sur les outils IA, les apps grand public et les produits data d'entreprise.",
  ja: 'Beiyi Data は、AIツール・コンシューマーアプリ・企業向けデータ製品に注力する独立系ソフトウェア企業です。',
}
const contactLabel = { zh: '联系', en: 'Contact', es: 'Contacto', fr: 'Contact', ja: '連絡先' }
const coopTitle = {
  zh: '合作与咨询',
  en: 'Partnership & Consulting',
  es: 'Cooperación y Consultoría',
  fr: 'Partenariat et Conseil',
  ja: '提携・ご相談',
}
const coopDescription = {
  zh: '支持 AI 工具合作、API 接入咨询、企业数据平台方案沟通与私有化部署评估。',
  en: 'Available for AI product partnership, API integration consulting, enterprise data platform planning, and private deployment evaluation.',
  es: 'Disponible para cooperación en productos de IA, consultoría de integración API y despliegue privado empresarial.',
  fr: "Disponible pour partenariats IA, conseil d'intégration API et déploiement privé entreprise.",
  ja: 'AIツール連携、API導入相談、企業データ基盤設計、プライベート導入評価に対応します。',
}
const responseLabel = { zh: '响应时间', en: 'Response', es: 'Respuesta', fr: 'Réponse', ja: '返信目安' }
const responseDescription = {
  zh: '常规合作邮件会在 1-2 个工作日内回复。复杂需求可先发送背景与目标，我们会安排详细评估。',
  en: 'General inquiries are usually replied to within 1-2 business days. For complex requests, share goals and background first.',
  es: 'Las consultas generales suelen responderse en 1-2 días hábiles. Para requisitos complejos, envíe contexto y objetivos.',
  fr: "Les demandes générales reçoivent une réponse sous 1-2 jours ouvrés. Pour les besoins complexes, envoyez d'abord le contexte.",
  ja: '通常のお問い合わせは1〜2営業日以内に返信します。複雑な要件は背景と目的を先に共有してください。',
}
const locationLabel = { zh: '所在地', en: 'Location', es: 'Ubicación', fr: 'Localisation', ja: '所在地' }
</script>
